import { ajaxWithRetry } from './ajaxWithRetry'
import PresenterModel from '@polleverywhere/core/lib/models/presenter'
import { NotFoundError } from './NotFoundError'

export async function loadPresenter (login) {
  login = login?.toLowerCase()

  return new Promise((resolve, reject) => {
    if (!login || !/^[A-Za-z0-9]+$/.test(login)) {
      return reject(new NotFoundError('Invalid presenter'))
    }

    const presenter = new PresenterModel({ login })

    ajaxWithRetry(presenter.fetch.bind(presenter), 3)
      .then(() => resolve(presenter))
      .catch((e) => {
        if (e?.status === 404) {
          reject(new NotFoundError('Invalid presenter'))
        } else {
          reject(e)
        }
      })
  })
}
